import {
  DialogTitle as MuiDialogTitle,
  DialogTitleProps as MuiDialogTitleProps,
  SxProps,
} from '@mui/material';
import { DialogTitleSx } from './DialogTitleProps';

type Props = MuiDialogTitleProps;

function DialogTitle(props: Props) {
  return (
    <MuiDialogTitle
      {...props}
      sx={{ ...DialogTitleSx, ...props.sx } as SxProps}
    />
  );
}

export default DialogTitle;
